<template>
  <section class="vision-mission rn-section-gap" aria-label="Vision and mission">
    <div class="container">
      <div class="vm-grid">
        <article class="vm-item vm-vision" data-aos="fade-up" data-aos-delay="100">
          <Icon name="compass" size="36" icon-class="vm-icon" />
          <h3 class="vm-title LexenSemiBold">{{ $t('About.vision_label') }}</h3>
          <p class="vm-statement">{{ $t('About.vision') }}</p>
        </article>

        <span class="vm-junction" aria-hidden="true" data-aos="fade-in" data-aos-delay="50">
          <span class="vm-node" />
        </span>

        <article class="vm-item vm-mission" data-aos="fade-up" data-aos-delay="200">
          <Icon name="zap" size="36" icon-class="vm-icon" />
          <h3 class="vm-title LexenSemiBold">{{ $t('About.mission_label') }}</h3>
          <p class="vm-statement">{{ $t('About.mission') }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from '../../icon/Icon'

export default {
  name: 'About',
  components: { Icon }
}
</script>
